import { store } from '../Redux/store';
import _, { isEmpty } from "lodash";
import momentJalaali from "moment-jalaali";
import { UpdateOrdersStatistics } from './update-ordersStatistics';

export const MatchOrderWithFiltersList = async (socketOrder, call) => {
  const storeData = store.getState();

  const isOrderTypeMatched = 
    storeData.OrderList.ActiveOrderType === socketOrder.type ||
    (storeData.ViewTravel.OpenDialoge && 
      storeData.ViewTravel.pureData?.type === socketOrder.type);

  if (isOrderTypeMatched) {
    const filters = [
      { name: "DateRange", fn: () => checkDateRange(socketOrder, storeData) },
      { name: "IsScheduled", fn: () => checkIsScheduled(socketOrder, storeData) },
      { name: "Service", fn: () => checkService(socketOrder, storeData) },
      { name: "Vehicle", fn: () => checkVehicle(socketOrder, storeData) },
      { name: "Zone", fn: () => checkZone(socketOrder, storeData) },
      { name: "DispatchLater", fn: () => checkDispatchLater(socketOrder, storeData) }
    ];

    const failedFilters = [];
    for (const filter of filters) {
      const passed = await filter.fn();
      if (!passed) {
        failedFilters.push(filter.name);
      }
    }

    if (failedFilters.length === 0) {
      call(true);
    } else {
      logOrderUpdate("G0", socketOrder, storeData, failedFilters);
    }
  } else {
    logOrderUpdate("G1", socketOrder, storeData, ["OrderType"]);
  }
};

const checkDateRange = async (socketOrder, storeData) => {
  const cursor = storeData.OrderList.cursor;
  const startDate = storeData.OrderList.DateRange?.startDate 
    ? momentJalaali(storeData.OrderList.DateRange.startDate).valueOf() 
    : null;
  const endDate = storeData.OrderList.DateRange?.endDate 
    ? momentJalaali(storeData.OrderList.DateRange.endDate).valueOf() 
    : null;

  const orderDate = Number(socketOrder[cursor]);

  console.log("dfewgwf ",startDate , endDate  , orderDate)

  if (startDate && orderDate < startDate) return false;
  if (endDate && orderDate > endDate) return false;

  return true;
};

const checkIsScheduled = async (socketOrder, storeData) => {
  const { now, isScheduled } = storeData.OrderList;
  if (now === isScheduled) return true;
  return _.isEqual(!!isScheduled, !!socketOrder.isScheduled);
};

const checkService = async (socketOrder, storeData) => {
  const selectedServices = safeParseJSON(storeData.OrderList.selectedServices);
  if (Array.isArray(selectedServices) && selectedServices.length > 0) {
    return selectedServices.includes(socketOrder.service.id);
  }
  return true;
};

const checkVehicle = async (socketOrder, storeData) => {
  if (socketOrder.status === "PickupDelivery") return true;

  const selectedVehicleType = safeParseJSON(storeData.OrderList.selectedVehicleType);
  if (Array.isArray(selectedVehicleType) && selectedVehicleType.length > 0) {
    return selectedVehicleType.includes(socketOrder.vehicleTypeId);
  }
  return true;
};

const checkZone = async (socketOrder, storeData) => {
  const zones = safeParseJSON(storeData.OrderList.zones);
  if (Array.isArray(zones) && zones.length > 0) {
    return zones.includes(socketOrder.zoneId);
  }
  return true;
};

const checkDispatchLater = async (socketOrder, storeData) => {
  if (!socketOrder.isScheduled) return true;

  const startDate = storeData.OrderList.DateRange?.startDate 
    ? momentJalaali(storeData.OrderList.DateRange.startDate).valueOf() 
    : null;
  const endDate = storeData.OrderList.DateRange?.endDate 
    ? momentJalaali(storeData.OrderList.DateRange.endDate).valueOf() 
    : null;

  if (startDate && endDate) {
    const locations = [
      socketOrder.pickup,
      socketOrder.dropoff,
      ...(socketOrder.dropoffs || [])
    ].filter(location => !isEmpty(location));

    return locations.some(location => 
      Number(location.scheduleDateAfter) >= startDate && 
      Number(location.scheduleDateAfter) <= endDate
    );
  }

  return true;
};

const safeParseJSON = (data) => {
  try {
    return JSON.parse(data);
  } catch {
    return [];
  }
};

const logOrderUpdate = (type, socketOrder, storeData, failedFilters = []) => {
  console.log(
    `dispatcher:order:updated ${type} `,
    socketOrder.id,
    momentJalaali(new Date()).format("HH : mm : ss"),
    failedFilters.length > 0 ? `Failed Filters: ${failedFilters.join(", ")}` : "All Filters Passed"
  );
};